// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"92":"b9b2e501","169":"14e53491","562":"6e97c778","928":"8ea82df3","948":"de8dccb7"}[chunkId] + ".chunk.css";
};